import router, { useRouter as useNextRouter } from 'next/router';

/**
 * Custom useRouter hook that works in both App Router and Pages Router.
 * @returns {Object} - Unified router API.
 */
export function useRouter() {
  // if (isAppRouter) {
  //   const router = useAppRouter();
  //   const searchParams = useSearchParams();
  //   const pathname = usePathname();

  //   console.log(pathname);

  //   const asPath = `${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  //   const basePath = pathname?.split('/').length > 0 ? pathname.split('/')[1] : '';

  //   return {
  //     push: (href: string | object, options?: NavigateOptions) =>
  //       router.push(typeof href === 'string' ? href : asPath, options),
  //     replace: router.replace,
  //     back: router.back,
  //     pathname,
  //     query: Object.fromEntries(searchParams.entries()),
  //     asPath,
  //     basePath,
  //     reload: () => window.location.reload(),
  //   };
  // } else {
  //   return useNextRouter();
  // }
  return useNextRouter();
}

// export const replace = isAppRouter ? redirect : router.replace;
export const replace = router.replace;
